"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useSimTokenInfo, type SimBalanceItem } from "@/hooks/useSimTokenInfo";
import { isNativeTokenAddress } from "@/lib/tokens/nativeToken";
import { useMemo, useState } from "react";
import { useChainInfo } from "../../workflows/_hooks/useChainInfo";
import { TokenHoverTooltipContent } from "./TokenHoverTooltipContent";
interface TokenHoverTooltipProps {
  token: Pick<SimBalanceItem, "address" | "chain_id" | "symbol"> & Partial<Omit<SimBalanceItem, "address" | "chain_id" | "symbol">>;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  sideOffset?: number;
}
export function TokenHoverTooltip(t0) {
  const $ = _c(33);
  const {
    token,
    children,
    side: t1,
    align: t2,
    sideOffset: t3
  } = t0;
  const side = t1 === undefined ? "top" : t1;
  const align = t2 === undefined ? "start" : t2;
  const sideOffset = t3 === undefined ? 10 : t3;
  const [open, setOpen] = useState(false);
  const {
    data: chainInfo
  } = useChainInfo(token.chain_id);
  let t4;
  if ($[0] !== open || $[1] !== token.address) {
    t4 = open && !isNativeTokenAddress(token.address);
    $[0] = open;
    $[1] = token.address;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    data: tokenInfo
  } = useSimTokenInfo(token.address, token.chain_id, t4);
  chainInfo?.name;
  tokenInfo?.tokens;
  let t5;
  const t6 = token.chain ?? chainInfo?.name ?? `Chain ${token.chain_id}`;
  const t7 = token.amount ?? "0";
  const t8 = token.symbol || tokenInfo?.tokens?.[0]?.symbol || "?";
  const t9 = token.decimals ?? tokenInfo?.tokens?.[0]?.decimals ?? 18;
  const t10 = token.price_usd ?? tokenInfo?.tokens?.[0]?.price_usd;
  const t11 = token.name ?? tokenInfo?.tokens?.[0]?.name;
  const t12 = token.token_metadata?.logo ?? tokenInfo?.tokens?.[0]?.logo ?? tokenInfo?.tokens?.[0]?.token_metadata?.logo;
  let t13;
  if ($[3] !== t12) {
    t13 = {
      logo: t12
    };
    $[3] = t12;
    $[4] = t13;
  } else {
    t13 = $[4];
  }
  const t14 = token.pool_size ?? tokenInfo?.tokens?.[0]?.pool_size;
  let t15;
  if ($[5] !== t10 || $[6] !== t11 || $[7] !== t13 || $[8] !== t14 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9 || $[13] !== token.address || $[14] !== token.chain_id || $[15] !== token.low_liquidity || $[16] !== token.value_usd) {
    t15 = {
      chain: t6,
      chain_id: token.chain_id,
      address: token.address,
      amount: t7,
      symbol: t8,
      decimals: t9,
      price_usd: t10,
      value_usd: token.value_usd,
      name: t11,
      token_metadata: t13,
      pool_size: t14,
      low_liquidity: token.low_liquidity
    };
    $[5] = t10;
    $[6] = t11;
    $[7] = t13;
    $[8] = t14;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = token.address;
    $[14] = token.chain_id;
    $[15] = token.low_liquidity;
    $[16] = token.value_usd;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  t5 = t15;
  const hydratedToken = t5;
  let t16;
  if ($[18] !== children) {
    t16 = <TooltipTrigger asChild={true}>{children}</TooltipTrigger>;
    $[18] = children;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = chainInfo ?? undefined;
  let t18;
  if ($[20] !== hydratedToken || $[21] !== open || $[22] !== t17) {
    t18 = <TokenHoverTooltipContent balance={hydratedToken} chainInfo={t17} open={open} />;
    $[20] = hydratedToken;
    $[21] = open;
    $[22] = t17;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== align || $[25] !== side || $[26] !== sideOffset || $[27] !== t18) {
    t19 = <TooltipContent side={side} align={align} sideOffset={sideOffset} className="!bg-ds-surface-raised !text-ds-text-primary border-ds-border-default max-w-none border p-0">{t18}</TooltipContent>;
    $[24] = align;
    $[25] = side;
    $[26] = sideOffset;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== open || $[30] !== t16 || $[31] !== t19) {
    t20 = <Tooltip open={open} onOpenChange={setOpen}>{t16}{t19}</Tooltip>;
    $[29] = open;
    $[30] = t16;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  return t20;
}